import { IStackItemStyles, IStackStyles } from "@fluentui/react";

export const scrollStackItemStyles: IStackItemStyles = {
};

export const stackStyle: IStackStyles = {
  root: { height: 510 }
}